import { media } from "@/styles/Qtheme.ts"
import { useIndexPrice } from '@app/hooks/trade/indexprice.tsx'
import { useInfo24H } from '@app/hooks/trade/info24H.tsx'
import { MobileCalVW } from "@utils/CalVW.tsx"
import BigNumber from 'bignumber.js'
import { useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import DeactiveStar from "./assets/DeactiveStar.svg?react"
import * as S from './style'


export default function CoinList({ data, trade }: any) {
  const navigation = useNavigate();

  // const { data: info24H } = useInfo24H(data?.id)

  const { getInfo24H } = useInfo24H();
  const info24H = getInfo24H(data?.id);

  const { getPrice } = useIndexPrice(data?.id)

  useEffect(() => {
    console.log(data)
  }, [data]);

  return (
    <S.List>
      <S.NameContainer>
        {data.image ? <img src={data.image} alt="" /> : <S.Icon />}
        <S.Name>{data?.main_symbol}</S.Name>
        {/*<S.FullName>{data?.name}</S.FullName>*/}
      </S.NameContainer>
      <S.Price>$ {BigNumber(getPrice(data?.id)).toFormat(4)}</S.Price>
      <S.Inde
        minus={
          BigNumber(info24H?.rate || 0)
            .toFormat(2)
            ?.split('')[0] === '-'
        }>
        {BigNumber(info24H?.rate || 0).toFormat(2)}%
      </S.Inde>

      <StarIconSVG as={DeactiveStar}/>
    </S.List>
  )
}


const StarIconSVG = styled.svg`
	width: 16px;
	height: 16px;

    @media ${media.mobile} {
        width: ${MobileCalVW(16)};
        height: ${MobileCalVW(16)};
    }
`

